import backgroundImage from './assets/login_bg.jpeg'

const FirebaseSessionKey =
  'firebase:authUser:AIzaSyD0OX3aNvkCTLhW_zfP6JGA9pUkLXWNsL8:[DEFAULT]'

const isMobile = window.innerWidth < 768

export { FirebaseSessionKey, backgroundImage, isMobile }
